import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'phoneNumber' })
export class PhoneNumberPipe implements PipeTransform {
    num;
    code;
    formattedNumber;
    transform(number: string): string {
        if (!number) { return ''; }
        number = String(number);
        this.num = number.split('-');
        if (this.num.length > 1) {
            this.code = this.num[0];
            number = this.num[1];
        } else {
            this.code = '';
            number = this.num[0];
        }
        number = number.replace(/[^0-9]*/g, '');
        this.formattedNumber = '+1 ' + number;
        const area = number.substring(0, 3);
        const front = number.substring(3, 6);
        const end = number.substring(6, 10);
        if (front) {
            this.formattedNumber = '+1-' + (area + '-' + front);
        }
        if (end) {
            this.formattedNumber += ('-' + end);
        }

        return this.formattedNumber;
    }
}
